export default __webpack_public_path__ + "static/media/1.1a3b3f9c.png";